export default "__VITE_ASSET__BDi_NsxQ__"